export const TX_STATUS_CONFIRMED = Symbol('TX_STATUS_CONFIRMED')
export const TX_STATUS_FAILED = Symbol('TX_STATUS_FAILED')
export const TX_STATUS_PENDING = Symbol('TX_STATUS_PENDING')
export const TX_STATUS_SIGNATURE_FAILED = Symbol('TX_STATUS_SIGNATURE_FAILED')
export const TX_STATUS_SIGNED = Symbol('TX_STATUS_SIGNED')
